import type { Accessor } from 'solid-js';
import type { ConfigFeatureFlagValues, FeatureFlagSource } from '../types';
import { getSourceFlagName, type FeatureFlag } from '../featureFlags';

/**
 * Feature flag source backed by static values, for example from a
 * per-environment config file.
 *
 * Answers synchronously, also before `initialize` resolves, so there is no
 * "off" flash at startup. The values are read through an accessor, so flags
 * re-evaluate when they change, which lets an app layer its own overrides on top.
 */
export class ConfigFeatureFlagProvider implements FeatureFlagSource {
  public readonly name = 'config';

  constructor(private readonly values: Accessor<ConfigFeatureFlagValues>) {}

  public initialize(): Promise<void> {
    return Promise.resolve();
  }

  public hasFlag(flag: FeatureFlag): boolean {
    const name = getSourceFlagName(flag, 'config');
    return name !== undefined && (this.values()[name] ?? false);
  }
}
